module.exports = __webpack_public_path__ + "img/haed.b9c32fcd.jpg";